import { Injectable } from '@angular/core';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { combine } from 'src/app/shared/utilities/route';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';
import { MinimumWageDetails } from '../models/minimum-wage-details.model';
import { FetchArgs, PagingToken } from 'src/app/shared/models/core';
import { MinimumWageRuleGridItem } from '../models/minimum-wage-rule-grid-item.model';
import { MinimumWageRuleGridLookups } from '../models/minimum-wage-rule-grid-lookups.model';

@Injectable({
    providedIn: 'root'
})
export class MinimumWageService extends MarginCalculatorBaseService {
    constructor(private readonly _http: HttpClient) {
        super();
    }

    getMinimumWage(
        facilityId: number,
        startDate: Date,
        professionId: number,
        specialtyId: number
    ): Observable<MinimumWageDetails> {
        const url = combine(this.coreApiPath, 'minimum-wage');
        const params = interpolateParams({ facilityId, startDate, professionId, specialtyId });
        return this._http.get<MinimumWageDetails>(url, { params });
    }

    getMinimumWageRuleGridLookups(): Observable<MinimumWageRuleGridLookups> {
        const url = `${this.coreApiPath}/minimum-wage/lookups`;
        return this._http.get<MinimumWageRuleGridLookups>(url);
    }

    searchMinimumWageRules(fetchArgs: FetchArgs): Observable<PagingToken<MinimumWageRuleGridItem[]>> {
        const url = `${this.coreApiPath}/minimum-wage/search`;
        return this._http.post<PagingToken<MinimumWageRuleGridItem[]>>(url, fetchArgs);
    }

    toggleMinimumWageRuleActive(minimumWageRuleId: number, enabled: boolean): Observable<void> {
        const url = `${this.coreApiPath}/minimum-wage/${minimumWageRuleId}/toggle-enabled/${enabled}`;
        return this._http.put<void>(url, null);
    }
}
